import React from 'react';

export const PageTitle = ({ children, className = "", subtitle }) => {
  return (
    <div className={`mb-6 ${className}`}>
      <h1
        style={{
          fontFamily: 'var(--font-display)',
          color: '#e8e6e0',
          fontSize: 'clamp(1.5rem, 4vw, 2.25rem)',
          fontWeight: 700,
          letterSpacing: '-0.02em',
          lineHeight: 1.4,
          paddingBottom: '0.1em',
          marginBottom: subtitle ? '0.375rem' : 0,
        }}
      >
        {children}
        <span style={{ display: 'inline-block', width: '0.35em', height: '0.35em', borderRadius: '50%', background: '#c9a84c', marginLeft: '0.2em', verticalAlign: 'middle', marginBottom: '0.1em' }} />
      </h1>
      {subtitle && (
        <p style={{ color: '#7a7870', fontFamily: 'var(--font-body)', fontSize: '0.8125rem' }}>{subtitle}</p>
      )}
    </div>
  );
};
